import { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { dig } from '../utils/object';

export const useNavbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState('');

  function handleOpen() {
    if (`/offers/search` != location.pathname) {
      navigate(`/offers/search`, { state: { from: location.pathname } });
    }
  }

  function handleClose() {
    setSearch('');
    const from = dig(location, ['state', 'from']);
    navigate(from || `/${location.pathname.split('/')[1]}`, { state: { from: null } });
  }

  return {
    handleClose,
    handleOpen,
    search,
    setSearch,
  };
};
